const BUSINESS_URL = '/business';

export const getAllBusinesses = () => BUSINESS_URL;

export const postBusinessCreditChange = (businessId) => `${BUSINESS_URL}/${businessId}/credit-change`;

export const updateBusiness = (id) => {
  const url = `${BUSINESS_URL}/${id}`;
  return url;
};
